import React from 'react';
import { Row, Col, Icon } from 'antd'
import { PDFExport } from '@progress/kendo-react-pdf';
import logo from '../../images/logos/service.png'
import moment from 'moment'

class PDFLayout extends React.Component {

  render() {

    const { data } = this.props
    const styles = {
      title: {
        fontSize: 18,
        color: '#006588',
        margin: 0,
        marginTop: 10,
        lineHeight: 1,
        letterSpacing: 1
      },
      phase: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#006588',
        lineHeight: 1,
        marginTop: 10,
        textAlign: 'center',
        letterSpacing: 1
      },
      text: {
        fontSize: 16,
        lineHeight: 1,
        letterSpacing: 1
      },
      projectTitle: {
        color: '#006588',
        margin: 0,
        fontSize: 24,
        fontWeight: 'bold',
        lineHeight: 1,
        letterSpacing: 1
      },
      border: {
        border: '1px solid #4a90e2',
        padding: '0px 5px',
        marginBottom: 10,
        borderRadius: 5
      },
      info: {
        lineHeight: 1
      }
    }
    return (
        <Row id='toExport' style={{ position: "absolute", border: '1px solid red',backgroundColor: 'white' ,top: 0, left: -2000 }}>
          <PDFExport
            paperSize={'A4'}
            fileName="Project Export.pdf"
            title=""
            ref={(r) => this.toExport = r}>
            <div style={{width: 525, padding: 40}}>
              <div style={{borderRadius: 5, border: '1px solid #006588', height: 120, marginBottom: 20, paddingTop: 10}}>
                <Col xs={6} style={{paddingLeft: 10}}>
                  <img style={{width: '65%', height: 'auto'}} src={logo} />
                </Col>
                <Col xs={15} style={{paddingLeft: 20}} >
                  <h3 style={Object.assign(styles.info, {marginTop: 5})}>{`${this.props.profile.profile.name} ${this.props.profile.profile.last_name}`}</h3>
                  <h3 style={styles.info}>{this.props.profile.profile.email}</h3>
                  <h3 style={styles.info}>{this.props.profile.profile.school.name}</h3>
                  <h3 style={styles.info}>{`Exported on ${moment().format('DD.MM.YYYY')}`}</h3>
                </Col>
              </div>
              <div style={{width: '100%', padding: 5, border: '1px solid #006588', borderRadius: 5}}>
                <h1 style={styles.projectTitle}>{data.projectTitle}</h1>
                <h1 style={styles.projectTitle}>{data.projectDescription}</h1>
              </div>

              <h3 style={styles.phase}>**** 1. INVESTIGATION ****</h3>
              <h3 style={styles.title}>Why? Identify & State Need</h3>
              <h3 style={styles.text}>{data.Investigation.identifyAndNeed}</h3>
              <h3 style={styles.title}>Learner profile attributes</h3>
              <Row style={{width: '100%'}}>
              {data.Investigation.learnerProfileAttribute && data.Investigation.learnerProfileAttribute.map( item => (
                <Col xs={8} style={{padding: 5, color: 'white'}}>
                  <div style={{backgroundColor: '#006588', borderRadius: 3, padding: 5}}>{item}</div>
                </Col>
              ))}
              </Row>
              <h3 style={styles.title}>Relevant Service Learning Outcomes</h3>
              <Row style={{width: '100%'}}>
              {data.Investigation.relevantServiceLearningOutcomes && data.Investigation.relevantServiceLearningOutcomes.map( item => (
                <Col xs={24} style={{padding: 5, color: 'white'}}>
                  <div style={{backgroundColor: '#006588', borderRadius: 3, padding: 5}}>{item}</div>
                </Col>
              ))}
              </Row>
              <h3 style={styles.title}>Type of Project</h3>
              <h3 style={styles.text}>{data.Investigation.projectType}</h3>
              <h3 style={styles.title}>Skills</h3>
              <Row style={{width: '100%'}}>
              {data.Investigation.ATLCategories && data.Investigation.ATLCategories.map( item => (
                <Col xs={8} style={{padding: 5, color: 'white'}}>
                  <div style={{backgroundColor: '#006588', borderRadius: 3, padding: 5}}>{item}</div>
                </Col>
              ))}
              </Row>
              <h3 style={styles.title}>Desired Impact</h3>
              <h3 style={styles.text}>{data.Investigation.desiredImpact}</h3>
              <h3 style={styles.title}>Notes</h3>
              <h3 style={styles.text}>{data.Investigation.notes}</h3>

              {data.Preparation && data.Preparation.is_complete &&
                <div>
                  <div style={{marginTop: 30, marginBottom: 30, width: '100%', height: 3, borderBottom: '1px solid #006588'}} />
                  <h3 style={styles.phase}>**** 2. PREPARATION ****</h3>
                  <h3 style={styles.title}>Who (Which organization(s))?</h3>
                  <h3 style={styles.text}>{data.Preparation.who}</h3>
                  <h3 style={styles.title}>Where (Which location(s))?</h3>
                  <h3 style={styles.text}>{data.Preparation.where}</h3>
                  <h3 style={styles.title}>When (Which timeframe / frequency)?</h3>
                  <h3 style={styles.text}>{data.Preparation.when}</h3>
                  <h3 style={styles.title}>How (What resources will I need)?</h3>
                  <h3 style={styles.text}>{data.Preparation.how}</h3>
                  <h3 style={styles.title}>Expected completion date</h3>
                  <h3 style={styles.text}>{moment.unix(data.Preparation.expectedCompletionDate).format('DD-MM-YYYY')}</h3>
                  <h3 style={styles.title}>Notes</h3>
                  <h3 style={styles.text}>{data.Preparation.notes}</h3>
                </div>
              }
              {data.Action && data.Action.is_complete &&
                <div>
                  <div style={{marginTop: 30, marginBottom: 30, width: '100%', height: 3, borderBottom: '1px solid #006588'}} />
                  <h3 style={styles.phase}>**** 3. ACTION ****</h3>
                  {data.Action.actionObject && Object.entries(data.Action.actionObject).map( item => (
                    <div style={{marginBottom: 10, border: '1px solid #006588', padding: 10, borderRadius: 3 }}>
                      <h3 style={styles.title}>{item[1].title}</h3>
                      <h3 style={styles.text}>{item[1].notes}</h3>
                      <h3 style={styles.text}>Attachments:</h3>
                      {item[1].downloadURL && item[1].downloadURL.map( attachment => (
                        <h3 style={styles.text}>{attachment.name}</h3>
                      ))}
                    </div>
                  ))}
                </div>
              }
              {data.Demonstration && data.Demonstration.is_complete &&
                <div>
                  <div style={{marginTop: 30, marginBottom: 30, width: '100%', height: 3, borderBottom: '1px solid #006588'}} />
                  <h3 style={styles.phase}>**** 4. DEMONSTRATION ****</h3>
                  <h3 style={styles.title}>Describe Your Demonstration</h3>
                  <h3 style={styles.text}>{data.Demonstration.description}</h3>
                  <h3 style={styles.title}>Notes</h3>
                  <h3 style={styles.text}>{data.Demonstration.notes}</h3>
                </div>
              }
              {data.Reflection && data.Reflection.is_complete &&
                <div>
                  <div style={{marginTop: 30, marginBottom: 30, width: '100%', height: 3, borderBottom: '1px solid #006588'}} />
                  <h3 style={styles.phase}>**** 5. REFLECTION ****</h3>
                  <h3 style={styles.title}>Learner profile attributes</h3>
                  <Row style={{width: '100%'}}>
                  {data.Reflection.learnerProfileAttribute && data.Reflection.learnerProfileAttribute.map( item => (
                    <Col xs={8} style={{padding: 5, color: 'white'}}>
                      <div style={{backgroundColor: '#006588', borderRadius: 3, padding: 5}}>{item}</div>
                    </Col>
                  ))}
                  </Row>
                  <h3 style={styles.title}>Relevant Service Learning Outcomes</h3>
                  <Row style={{width: '100%'}}>
                  {data.Reflection.learningOutcomes && data.Reflection.learningOutcomes.map( item => (
                    <Col xs={24} style={{padding: 5, color: 'white'}}>
                      <div style={{backgroundColor: '#006588', borderRadius: 3, padding: 5}}>{item}</div>
                    </Col>
                  ))}
                  </Row>
                  <h3 style={styles.title}>Skills</h3>
                  <Row style={{width: '100%'}}>
                  {data.Reflection.ATLCategories && data.Reflection.ATLCategories.map( item => (
                    <Col xs={8} style={{padding: 5, color: 'white'}}>
                      <div style={{backgroundColor: '#006588', borderRadius: 3, padding: 5}}>{item}</div>
                    </Col>
                  ))}
                  </Row>
                  <h3 style={styles.title}>Impact</h3>
                  <h3 style={styles.text}>{data.Reflection.actualImpact}</h3>
                  <h3 style={styles.title}>Reflection</h3>
                  <h3 style={styles.text}>{data.Reflection.writeReflection}</h3>
                  <h3 style={styles.title}>Notes</h3>
                  <h3 style={styles.text}>{data.Reflection.notes}</h3>
                  <h3 style={styles.title}>Attachments</h3>
                  {data.Reflection.uploadEvidence && data.Reflection.uploadEvidence.map( item =>
                    <h3 style={styles.text}>{item.name}</h3>
                  )}
                </div>
              }
            </div>
            </PDFExport>
      </Row>
    )
  }
}

export default PDFLayout;



// WEBPACK FOOTER //
// ./src/components/PDFLayout/serviceTracker_student.jsx